import { Component, Input } from '@angular/core';

@Component({
  selector: 'wsb-atlas-dropdown',
  templateUrl: './atlas-dropdown.component.html',
  styleUrls: ['./atlas-dropdown.component.scss'],
  standalone: false
})
export class AtlasDropdownComponent {
  @Input() public label = '';
  @Input() public variant: 'primary' | 'secondary' | 'tertiary' | 'link' | 'danger' | 'primary-action' | 'icon' | 'outline-primary' =
    'primary';
  @Input() public roundButton = true;
  @Input() public size: 'sm' | 'lg' | null = null;
}
